<template>
    <v-card>
        <div>
            <v-img
                :src="rede.capa || require('@/assets/posto-default.png')"
                aspect-ratio="2.75"
            >
                <v-layout pa-2 column fill-height class="lightbox white--text">
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <v-btn
                            color="white"
                            dark
                            flat
                            @click="() => qrcode = !qrcode"
                        >
                            {{qrcode ? 'ESCONDER' : 'VER'}} QR-CODE
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-img>
        </div>
        <v-card-text>
            <template v-if="qrcode">
                <v-container grid-list-md fluid v-if="rede && rede.matriz">
                  <v-layout row wrap fill-height>
                    <v-flex xs12 class="text-xs-center">
                      <span class="headline secondary--text">QR Code {{rede.matriz.nome_fantasia}}</span>
                      <div>
                      <span class="headline secondary--text">CNPJ {{rede.matriz.cnpj}}</span>
                      </div>
                      <v-layout justify-center align-center fill-height>
                        <template>
                          <qrcode-vue ref="qrcode" renderAs="svg" :value="link" size="300" level="H"></qrcode-vue>
                        </template>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                    <v-btn flat block color="primary" @click="exportSVG()">
                    Baixar
                    </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
            </template>
            <v-layout pt-4 row wrap justify-space-around fill-height>
              <v-flex xs12 sm11>
                  <v-text-field
                      readonly
                      label="Nome Fantasia"
                      v-model="rede.nome"
                  ></v-text-field>
              </v-flex>
                <v-flex xs12 sm5 v-if="rede && rede.matriz">
                    <v-text-field
                        readonly
                        label="Razão Social"
                        v-model="rede.matriz.razao_social"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 v-if="rede && rede.matriz">
                    <v-text-field
                        readonly
                        label="Nome Fantasia"
                        v-model="rede.matriz.nome_fantasia"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 v-if="rede && rede.matriz">
                    <v-text-field
                        readonly
                        label="CNPJ"
                        v-model="rede.matriz.cnpj"
                        mask="##.###.###/####-##"
                        class="text-xs-center"
                    ></v-text-field>
                </v-flex>
                <template v-if="rede.representante">
                  <v-flex xs12 sm5>
                      <v-text-field
                          readonly
                          label="CPF do representante"
                          v-model="rede.representante.cpf"
                          mask="###.###.###-##"
                          class="text-xs-center"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Nome do Representante"
                          v-model="rede.representante.nome"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Sobrenome do Representante"
                          v-model="rede.representante.sobrenome"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Telefone do Representante"
                          v-model="rede.representante.telefone"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs5>
                      <v-text-field
                          readonly
                          label="Email do Representante"
                          v-model="rede.representante.email"
                      ></v-text-field>
                  </v-flex>
              </template>
              <template v-if="rede && rede.matriz && rede.matriz.endereco">
                <v-flex xs12 class="text-xs-center pt-2 pb-2">
                  <h2 class="gray--text">
                    Endereço do Posto Matriz
                  </h2>
                </v-flex>
                <v-flex xs8>
                    <v-text-field
                        readonly
                        label="Logradouro"
                        v-model="rede.matriz.endereco.logradouro"
                    ></v-text-field>
                </v-flex>
                <v-flex xs2>
                    <v-text-field
                        readonly
                        label="Número"
                        v-model="rede.matriz.endereco.numero"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        readonly
                        label="Cidade"
                        v-model="rede.matriz.endereco.cidade"
                    ></v-text-field>
                </v-flex>
                <v-flex xs5>
                    <v-text-field
                        readonly
                        label="Bairro"
                        v-model="rede.matriz.endereco.bairro"
                    ></v-text-field>
                </v-flex>
                <v-flex xs3>
                    <v-text-field
                        readonly
                        label="Estado"
                        v-model="rede.matriz.endereco.estado"
                    ></v-text-field>
                </v-flex>
                <v-flex xs2>
                    <v-text-field
                        readonly
                        label="País"
                        v-model="rede.matriz.endereco.pais"
                    ></v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-text-field
                        readonly
                        label="CEP"
                        v-model="rede.matriz.endereco.cep"
                        mask="#####-###"
                    ></v-text-field>
                </v-flex>
              </template>
              <template v-if="postos.length > 0">
                <v-flex xs12 class="text-xs-center pt-2 pb-2">
                  <h2 class="gray--text">
                    Postos da Rede
                  </h2>
                </v-flex>
                <v-flex xs12>
                  <v-list>
                    <v-list-tile v-for="(item, index) in postos" :key="index" @click="postoSelecionado = item, dialogDetalhes = true">
                      <v-list-tile-avatar>
                        <v-icon>local_gas_station</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.nome_fantasia }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.cnpj }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </template>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="$emit('fechar')">Voltar</v-btn>
        </v-card-actions>
        <v-dialog lazy width="600" v-model="dialogDetalhes" :fullscreen="$vuetify.breakpoint.xs">
          <detalhes-posto :posto="postoSelecionado" @fechar="dialogDetalhes = false, postoSelecionado = undefined"></detalhes-posto>
        </v-dialog>
    </v-card>
</template>

<script>

import settings from '@/settings'
import QrcodeVue from 'qrcode.vue'
import { saveAs } from 'file-saver'
import DetalhesPosto from '@/components/dialogs/DetalhesPosto'

export default {
  components: { QrcodeVue, DetalhesPosto },
  props: ['rede'],
  data () {
    return {
      qrcode: false,
      postos: [],
      dialogDetalhes: false,
      postoSelecionado: undefined
    }
  },
  computed: {
    link () {
      if (this.rede.matriz) return `${settings.apetrusGo}/${this.rede.matriz.cnpj}/`
      return undefined
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    if (this.rede) {
      this.carregarRedes()
    }
  },
  watch: {
    rede (val) {
      if (val) {
        this.carregarRedes()
      }
    }
  },
  methods: {
    exportSVG () {
      var svg = this.$refs.qrcode.$el
      // first create a clone of our svg node so we don't mess the original one
      var clone = svg.cloneNode(true)
      // parse the styles
      this.parseStyles(clone)

      // create a doctype
      var svgDocType = document.implementation.createDocumentType('svg', '-//W3C//DTD SVG 1.1//EN', 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd')
      // a fresh svg document
      var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType)
      // replace the documentElement with our clone
      svgDoc.replaceChild(clone, svgDoc.documentElement)
      // get the data
      var svgData = (new XMLSerializer()).serializeToString(svgDoc)

      // now you've got your svg data, the following will depend on how you want to download it
      // e.g yo could make a Blob of it for FileSaver.js
      /*
      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, 'myAwesomeSVG.svg')
      */
      // here I'll just make a simple a with download attribute

      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, `qrcode-${this.rede.matriz.nome_fantasia}.svg`)

      // var a = document.createElement('a')
      // a.href = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgData.replace(/></g, '>\n\r<'))
      // a.download = 'myAwesomeSVG.svg'
      // a.innerHTML = 'download the svg file'
      // document.body.appendChild(a)
    },
    parseStyles (svg) {
      var styleSheets = []
      var i
      // get the stylesheets of the document (ownerDocument in case svg is in <iframe> or <object>)
      var docStyles = svg.ownerDocument.styleSheets

      // transform the live StyleSheetList to an array to avoid endless loop
      for (i = 0; i < docStyles.length; i++) {
        styleSheets.push(docStyles[i])
      }

      if (!styleSheets.length) {
        return
      }

      var defs = svg.querySelector('defs') || document.createElementNS('http://www.w3.org/2000/svg', 'defs')
      if (!defs.parentNode) {
        svg.insertBefore(defs, svg.firstElementChild)
      }
      svg.matches = svg.matches || svg.webkitMatchesSelector || svg.mozMatchesSelector || svg.msMatchesSelector || svg.oMatchesSelector

      // iterate through all document's stylesheets
      for (i = 0; i < styleSheets.length; i++) {
        var currentStyle = styleSheets[i]

        var rules
        try {
          rules = currentStyle.cssRules
        } catch (e) {
          continue
        }
        // create a new style element
        var style = document.createElement('style')
        // some stylesheets can't be accessed and will throw a security error
        var l = rules && rules.length
        // iterate through each cssRules of this stylesheet
        for (var j = 0; j < l; j++) {
          // get the selector of this cssRules
          var selector = rules[j].selectorText
          // probably an external stylesheet we can't access
          if (!selector) {
            continue
          }

          // is it our svg node or one of its children ?
          if ((svg.matches && svg.matches(selector)) || svg.querySelector(selector)) {
            var cssText = rules[j].cssText
            // append it to our <style> node
            style.innerHTML += cssText + '\n'
          }
        }
        // if we got some rules
        if (style.innerHTML) {
          // append the style node to the clone's defs
          defs.appendChild(style)
        }
      }
    },
    carregarRedes () {
      this.$store.dispatch('pegarPostosPorRede', {
        id: this.rede.id_rede
      }).then(json => {
        this.postos = json
      })
    }
  }
}
</script>
<style>
  .v-navigation-drawer {
    transition: none !important;
  }

  .lightbox {
    box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
  }
</style>
